import React from "react";

const OrgLogout = () => {
  return <div>OrgLogout</div>;
};

export default OrgLogout;
